import React from 'react';
import { MailIcon, ClockIcon, GlobeIcon } from 'lucide-react';
import { site } from '../../data/site';
export function ContactSection() {
  return <section id="contact" className="w-full border-t border-navy-100 bg-white" data-id="element-112" data-mp="6pp1eauhiyuf">
      <div className="mx-auto max-w-content px-6 py-24" data-id="element-113" data-mp="kox1r72dwd07">
        <div className="overflow-hidden rounded-3xl border border-navy-100 bg-brand-indigo/[0.04]" data-id="element-114" data-mp="fo996gyibo3v">
          <div aria-hidden="true" className="h-1.5 w-full bg-gradient-to-r from-brand-cyan via-brand-indigo to-brand-violet" data-id="element-115" data-mp="ul04ae15edno" />
          <div className="grid gap-12 p-8 sm:p-12 lg:grid-cols-2 lg:p-14" data-id="element-116" data-mp="13e3n71ukbipp">
            <div data-id="element-117" data-mp="13dbohi5o54v7">
              <h2 className="text-3xl font-bold tracking-tight text-navy-800 sm:text-4xl" data-id="element-118" data-mp="13fxwtk0dvoeh">
                Contact Us
              </h2>
              <span aria-hidden="true" className="mt-4 block h-1 w-16 rounded-full bg-gradient-to-r from-brand-cyan to-brand-violet" data-id="element-119" data-mp="1dbht47iv0p3r" />
              <p className="mt-6 max-w-lg text-lg leading-relaxed text-navy-600" data-id="element-120" data-mp="3lilaughqstmk">
                If you have any questions about our business, digital products,
                delivery, or policies, you can contact us by email.
              </p>
              <p className="mt-4 text-base text-navy-500" data-id="element-121" data-mp="3vey4xfh799hu">
                We typically respond within 1–2 business days.
              </p>
            </div>

            <div className="space-y-5" data-id="element-122" data-mp="8cbiglz8o4l9">
              <div className="flex items-start gap-4 rounded-2xl border border-brand-indigo/20 bg-white p-6" data-id="element-123" data-mp="8ba2q47a2tx7">
                <span className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brand-indigo/10 text-brand-indigo" data-id="element-124" data-mp="d91sosod45yr">
                  <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-125" data-mp="n17oyelnd9jr" />
                </span>
                <div className="min-w-0" data-id="element-126" data-mp="r2t6id94mc0a">
                  <h3 className="text-sm font-semibold text-navy-800" data-id="element-127" data-mp="r3vxsmad2ggq">
                    Email support
                  </h3>
                  <a href={`mailto:${site.supportEmail}`} className="mt-1 block break-all text-base font-medium text-brand-indigo underline-offset-4 hover:text-brand-violet hover:underline" data-id="element-128" data-mp="vz1fta0n7azj">
                    {site.supportEmail}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 rounded-2xl border border-brand-violet/20 bg-white p-6" data-id="element-129" data-mp="2x2kei5hj4x6j">
                <span className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brand-violet/10 text-brand-violet" data-id="element-130" data-mp="3br6xqiaa2931">
                  <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="3kt7tfapv4n2l" />
                </span>
                <div data-id="element-132" data-mp="3fu3iofnaiha5">
                  <h3 className="text-sm font-semibold text-navy-800" data-id="element-133" data-mp="3ftlf0xyat0s7">
                    Response time
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-navy-500" data-id="element-134" data-mp="1qfyeh3ejs9cy">
                    Customer support inquiries are typically answered within 1–2
                    business days.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 rounded-2xl border border-brand-cyan/30 bg-white p-6" data-id="element-135" data-mp="5wuwqx48z047">
                <span className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brand-cyan/10 text-brand-cyan" data-id="element-136" data-mp="3obnck3xgeuvl">
                  <GlobeIcon className="h-5 w-5" aria-hidden="true" data-id="element-137" data-mp="3sb5xgzp9z5yf" />
                </span>
                <div data-id="element-138" data-mp="3ec64jfuqc4wg">
                  <h3 className="text-sm font-semibold text-navy-800" data-id="element-139" data-mp="3ef0s3g91i5u3">
                    Business operator
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-navy-500" data-id="element-140" data-mp="35cj5v1tdxd73">
                    {site.brandName} is operated by {site.legalEntity}, a
                    Wyoming limited liability company conducting business
                    online.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}